<template>
  <ul class="flex flex-wrap -m-2">
    <slot name="before" />
    <li v-for="(filterValue, filterName) in filters" :key="filterName" class="p-2">
      <ActiveFilterListItem :filter="filterName" :value="filterValue" @remove="removeFilter" />
    </li>
  </ul>
</template>

<script>
import { omit } from 'lodash-es';
import ActiveFilterListItem from './active-filter-list-item.vue';

export default {
  components: {
    ActiveFilterListItem,
  },
  props: {
    action: {
      type: Function,
      required: true,
    },
    filters: {
      type: Object,
      required: true,
    },
  },
  data() {
    return {
      loading: false,
    };
  },
  methods: {
    setLoading(loading = true) {
      this.loading = loading;
    },
    async removeFilter(filter) {
      if (this.loading) {
        return;
      }

      try {
        this.setLoading();

        this.$emit('loading');

        const currentFilters = { ...this.filters };
        const remainingFilters = omit(currentFilters, [filter]);
        await this.action(remainingFilters);
      } catch (error) {
        // do something
      } finally {
        this.setLoading(false);

        this.$emit('loaded');
      }
    },
  },
};
</script>
